//bao migrate skip
import * as ko from "knockout";
import * as $ from "jquery";
var bindingName = "rekTemplate";
ko.virtualElements.allowedBindings[bindingName] = true;
ko.bindingHandlers[bindingName] = {
    init: function (elem, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
        if (bindingContext["__template"] == null) {
            var child = elem.nextSibling, childElems = [], template = "";
            while (child) {
                if (child.nextSibling != null) {
                    if (child.nodeType == 3) {
                        template = template + child.textContent;
                    }
                    else if (child.nodeType == 1) {
                        template = template + child.outerHTML;
                    }
                    else if (child.nodeType == 8) {
                        template = template + "<!--" + child.nodeValue + "";
                    }
                    childElems.push(child);
                }
                child = child.nextSibling;
            }
            bindingContext["__template"] = template;
        }
        return ko.bindingHandlers.foreach.init(elem, valueAccessor, allBindingsAccessor, viewModel, bindingContext);
    },
    update: function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
        ko.bindingHandlers.foreach.update(element, valueAccessor, allBindingsAccessor, viewModel, bindingContext);
    }
};